import Teaser from '@/components/teaser/Teaser'
import Notifications from '@/components/notifications/Notifications'
import Settings from '@/components/settings/Settings'
import Login from '@/components/auth/Login'
import Confirmation from '@/components/auth/Confirmation'
import Signup from '@/components/auth/Signup'
import SignupStart from '@/components/auth/SignupStart'
import SignupAgent from '@/components/auth/agent/Step2'
import SignupSupplier from '@/components/auth/supplier/Step2'
import ForgotPassword from '@/components/auth/ForgotPassword'
import ResetPassword from '@/components/auth/ResetPassword'
import Calendar from '@/components/calendar/Calendar'
import Reservations from '@/components/reservations/Reservations'
import ReservationForm from '@/components/reservations/Form'
import RebookReservation from '@/components/reservations/NewReservation/SearchRebook'
import NewReservation from '@/components/reservations/NewReservation/Search'
import NewReservationAvailability from '@/components/reservations/NewReservation/Availability'
import NewReservationResume from '@/components/reservations/NewReservation/Resume'
import People from '@/components/people/People'
import AgentNew from '@/components/people/agents/AgentNew'
import Invoices from '@/components/invoices/Invoices'
import Reports from '@/components/dashboard/dashboard'
import Inventory from '@/components/inventory/Inventory'
import CategoryForm from '@/components/inventory/categories/CategoryForm'
import ExtraForm from '@/components/inventory/extras/ExtraForm'
import ResourceForm from '@/components/inventory/resources/ResourceForm'
import ProductForm from '@/components/inventory/products/ProductForm'
import ProductNew from '@/components/inventory/products/ProductNew'
import ProductSchedule from '@/components/inventory/products/ProductSchedule'
import ProductPrices from '@/components/inventory/products/ProductPrices'
import ProductExtras from '@/components/inventory/products/ProductExtras'
import ProductResources from '@/components/inventory/products/ProductResources'
import Error403 from '@/components/errors/403'
import Error404 from '@/components/errors/404'
import Error502 from '@/components/errors/502'
import Logout from '@/components/auth/Logout'
import ConditionsEN from '@/components/other/conditions/Conditions_en'
import Promocodes from '@/components/promocodes/Promocodes'
import PromocodeCreate from '@/components/promocodes/promocodeCreate'
import PromocodeEdit from '@/components/promocodes/promocodeEdit'
import WidgetCostumize from '@/components/widget/WidgetCostumize'
import Rules from '@/components/revenue/Rules'
import NewRulesGroup from '@/components/revenue/rules/NewRulesGroup'
import NewRule from '@/components/revenue/rules/NewRule'

export const routes = [
    {
        path: '/teaser',
        name: 'teaser.teaser',
        component: Teaser,
    },
    {
        path: '/tos',
        name: 'basic.terms',
        component: ConditionsEN,
    },
    {
        path: '/widget-costumize/:widgetGuid',
        name: 'basic.costumize',
        component: WidgetCostumize,
    },
    {
        path: '/',
        name: 'dashboard',
        component: Reports,
        meta: {
            protected: true,
            requestedAccessType:[1]
        }
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: Notifications,
        meta: {
            protected: true
        }
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: {
            protected: true,
            requestedAccessType:[1]
        }
    },
    {
        path: '/login',
        name: 'auth.login',
        component: Login,
    },
    {
        path: '/signup',
        name: 'auth.signup',
        component: Signup,
    },
    {
        path: '/signup/agent',
        name: 'auth.signup.agent',
        component: SignupStart
    },
    {
        path: '/signup/agent/create',
        name: 'auth.signup.agent.create',
        component: SignupAgent
    },
    {
        path: '/signup/confirmation',
        name: 'auth.signup.confirmation',
        component: Confirmation,
    },
    {
        path: '/signup/supplier',
        name: 'auth.signup.supplier',
        component: SignupStart
    },
    {
        path: '/signup/supplier/create',
        name: 'auth.signup.supplier.create',
        component: SignupSupplier
    },
    {
        path: '/signup/forgot',
        name: 'auth.signup.forgot',
        component: ForgotPassword,
        meta: {
            protected: false
        }
    },
    {
        path: '/signup/reset',
        name: 'auth.signup.reset',
        component: ResetPassword,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservations/view/:reservationId',
        name: 'reservationsViewEventId',
        component: Reservations,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservations',
        name: 'reservations',
        component: Reservations,
        meta: {
            protected: false
        }
    },
    {
        path: '/events/:eventId/reservations',
        name: 'reservationsByEventId',
        component: Reservations,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservationsEvent',
        name: 'reservationsEvent',
        component: Reservations,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservations/new',
        name: 'pluralo.reservation.new',
        component: ReservationForm,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservation',
        name: 'pluralo.reservation',
        component: NewReservation,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservation/rebook/:id',
        name: 'pluralo.reservation.rebook',
        component: RebookReservation,
        meta: {
            protected: false,
            reschedule: true
        }
    },
    {
        path: '/reservation/availability',
        name: 'pluralo.reservation.availability',
        component: NewReservationAvailability,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservation/reschedule/:id',
        name: 'pluralo.reservation.reschedule',
        component: NewReservationAvailability,
        meta: {
            protected: false,
            reschedule: true
        },
    },
    {
        path: '/reservation/resume',
        name: 'pluralo.reservation.resume',
        component: NewReservationResume,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservation/resume/:id',
        name: 'pluralo.reservation.resume.id',
        component: NewReservationResume,
        meta: {
            protected: false
        }
    },
    {
        path: '/reservations/edit',
        name: 'pluralo.reservation.edit',
        component: ReservationForm
    },
    {
        path: '/inventory',
        name: 'inventory',
        component: Inventory,
        meta: {
            requestedAccessType:[1]
        }
    },
    {
        path: '/category/edit/:id',
        name: 'pluralo.category.edit',
        component: CategoryForm,
        meta: {
            protected: true
        }
    },
    {
        path: '/extra/edit/:id',
        name: 'pluralo.extra.edit',
        component: ExtraForm,
        meta: {
            protected: true
        }
    },
    {
        path: '/resource/edit/:id',
        name: 'pluralo.resource.edit',
        component: ResourceForm,
        meta: {
            protected: true
        }
    },
    {
        path: '/product/new',
        name: 'pluralo.product.new',
        component: ProductNew,
        meta: {
            protected: true
        },
        children: [
            {
                path: 'schedule',
                name: 'pluralo.product.new.schedule',
                component: ProductSchedule,
            },
            {
                path: 'prices',
                name: 'pluralo.product.new.prices',
                component: ProductPrices,
            },
            {
                path: 'extras',
                name: 'pluralo.product.new.extras',
                component: ProductExtras,
            },
            {
                path: 'resources',
                name: 'pluralo.product.new.resources',
                component: ProductResources,
            }
        ],
    },
    {
        path: '/product/edit/:id',
        name: 'pluralo.product.edit',
        component: ProductForm,
        meta: {
            protected: true
        }
    },
    {
        path: '/agents',
        name: 'agents',
        component: People,
        meta: {
            protected: true,
            requestedAccessType:[1]
        }
    },
    {
        path: '/agent/new',
        name: 'pluralo.agent.new',
        component: AgentNew,
        meta: {
            protected: true
        }
    },
    {
        path: '/agent/accept',
        name: 'pluralo.agent.accept',
        component: AgentNew,
        meta: {
            protected: true
        }
    },
    {
        path: '/invoices',
        name: 'invoices',
        component: Invoices,
        meta: {
            protected: true,
            requestedAccessType:[1]
        }
    },
    {
        path: '/promocodes',
        name: 'promocodes',
        component: Promocodes,
        meta: {
            protected: true,
            requestedAccessType:[1]
        }
    },
    {
        path: '/promocodes/new',
        name: 'newpromocode',
        component: PromocodeCreate,
        meta: {
            protected: true,
            requestedAccessType:[1]
        }
    },
    {
        path: '/promocodes/edit',
        name: 'editpromocode',
        component: PromocodeEdit,
        meta: {
            protected: true,
            requestedAccessType:[1]
        }
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: Calendar,
        meta: {
            protected: true
        }
    },
    {
        path: '/calendar/:currentView/:expandedDay/events/:eventID',
        name: 'calendarExpandedWithEventId',
        component: Calendar,
        meta: {
            protected: true
        }
    },
    {
        path: '/calendar/:currentView/:expandedDay/events/:eventID/edit',
        name: 'calendarExpandedWithEventIdEdit',
        component: Calendar,
        meta: {
            protected: true
        }
    },
    {
        path: '/calendar/:currentView/:expandedDay',
        name: 'calendarExpanded',
        component: Calendar,
        meta: {
            protected: true
        }
    },
    {
        path: '/rules',
        name: 'rules',
        component: Rules,
        meta: {
            protected: true,
        }
    },
    {
        path: '/rules/newGroup',
        name: 'pluralo.rulesGroup.new',
        component: NewRulesGroup,
        meta: {
            protected: true
        },
    },
    {
        path: '/rules/newRule',
        name: 'pluralo.rules.new',
        component: NewRule,
        meta: {
            protected: true
        },
    },
    {
        path: '/rules/editRule',
        name: 'pluralo.rules.editRule',
        component: NewRule,
        meta: {
            protected: true
        },
    },
    {
        path: '/rules/editRulesGroups',
        name: 'pluralo.rules.editRuleGroup',
        component: NewRulesGroup,
        meta: {
            protected: true
        },
    },
    {
        path: '/403',
        name: 'error.403',
        component: Error403,
    },    {
        path: '/404',
        name: 'error.404',
        component: Error404,
    },    {
        path: '/502',
        name: 'error.502',
        component: Error502,
    }
];



// WEBPACK FOOTER //
// ./src/routes/routes.js